import { Injectable } from '@angular/core';

@Injectable()
export class NotesModel {

  constructor() { }

}